import ToggleUIConfig from 'models/ButtonConfig';
import { ADULT, DEFAULT_PROFILE_PIC, DEFAULT_LOCALE } from 'helpers/ProfileConstants';

export const FALLBACK_AVATAR =
    'https://wwwimage-secure.cbsstatic.com/base/files/asset/10/00/96/99/3b80b0fcf28539c8_fallback_avatar.png';

export class UserProfile {
    constructor() {
        this.id = null;
        this.name = null;
        this.profilePic = DEFAULT_PROFILE_PIC;
        this.profilePicPath = null;
        this.profileType = ADULT;
        this.locale = DEFAULT_LOCALE;
    }
}


export const UserProfileCreateConfig = (getLocale) => {
    return {
        inputList: {
            profileName: {
                value: '',
                type: 'text',
                label: getLocale('profile_name'),
                tabIndex: 1,
                ref: 'profile_name',
                maxlength: 50,
                styleClass: ['qt-emailtxtfield']
            },
            ageGroupSwitch: new ToggleUIConfig({
                id: 'parental-switch',
                value: false,
                styleClass: 'switch-toggle-dark'
            })
        },
        buttonSubmitConfig: {
            type: 'submit',
            displayText: getLocale('save_profile'),
            tabIndex: 3,
            styleClass: ['button', 'primary', 'focusable']
        },
        buttonCancelConfig: {
            type: 'button',
            displayText: getLocale('save_profile_cancel'),
            tabIndex: 3,
            styleClass: ['button', 'secondary', 'focusable']
        },
        buttonDeleteConfig: {
            type: 'button',
            displayText: getLocale('delete_profile_'),
            tabIndex: 3,
            styleClass: ['button', 'secondary', 'focusable']
        },
        buttonCreatePin: {
            type: 'submit',
            displayText: 'CREATE PIN',
            tabIndex: 3,
            styleClass: ['button', 'primary', 'focusable'],
        },
    };
};

export const UserProfileDeleteConfig = (getLocale) => {
    return {
        buttonConfig: {
            submit: {
                displayText: getLocale('yes_delete_profile'),
                styleClass: ['button', 'primary', 'focusable']
            },
            cancel: {
                displayText: getLocale('no_keep_profile_'),
                styleClass: ['button', 'secondary', 'focusable']
            }
        }
    };
};
